import React, { useState, useEffect } from 'react'

import { useProject } from 'hooks'

import Editor from './Editor'

import './DataElementsForm.scss'

export default function DataElementsForm() {
  const { project, updateProjectPart, canEdit } = useProject()
  const [dataElements, setDataElements] = useState(project?.dataElements || [])
  const [shouldSave, setShouldSave] = useState(false)

  const onSave = content => {
    setShouldSave(true)
    setDataElements(content)
  }

  useEffect(() => {
    if (dataElements && shouldSave) updateProjectPart('dataElements', dataElements)
  }, [dataElements, shouldSave])

  return (
    <div className='data-elements-form'>
      <Editor properties={dataElements} onSave={onSave} disabled={!canEdit} />
    </div>
  )
}
